import service from './request';

/**
 * 搜索相关API接口
 */
const searchApi = {

  /**
   * 搜索消防法规（支持基础搜索和高级搜索）
   * @param {Object} searchParams - 搜索参数
   * @param {string} searchParams.query - 搜索关键词
   * @param {string} [searchParams.type] - 搜索类型（title/file/both）
   * @param {number} [searchParams.page=1] - 页码
   * @param {number} [searchParams.limit=10] - 每页条数
   * @param {string} [searchParams.searchMode] - 检索方式（exact/fuzzy）
   * @param {string} [searchParams.effectiveStart] - 实行日期开始
   * @param {string} [searchParams.effectiveEnd] - 实行日期结束
   * @param {string} [searchParams.promulgationStart] - 公布日期开始
   * @param {string} [searchParams.promulgationEnd] - 公布日期结束
   * @param {string} [searchParams.promulgatingAgency] - 制定机关（逗号分隔）
   * @param {string} [searchParams.legalLevel] - 法律效力位阶（逗号分隔）
   * @param {string} [searchParams.validity] - 时效性状态数组
   * @returns {Promise}
   */
  searchRegulations: (searchParams) => {
    // 提取基础参数（必传）
    const baseParams = {
      keyword: searchParams.query,
      type: searchParams.type,
      pageNum: searchParams.page,
      pageSize: searchParams.limit,
      searchMode: searchParams.searchMode,
      titleKey: searchParams.type === 'both' ? searchParams.query.split('&')[0]?.trim() : '',
      contentKey: searchParams.type === 'both' ? searchParams.query.split('&')[1]?.trim() : ''
    };

    const {
      effectiveStart,
      effectiveEnd,
      promulgationStart,
      promulgationEnd,
      promulgatingAgency,
      legalLevel,
      validity
    } = searchParams;

    // 判断是否使用了高级参数（至少存在一个高级参数即视为高级搜索）
    const hasAdvancedParams = !!(
        effectiveStart ||
        effectiveEnd ||
        promulgationStart ||
        promulgationEnd ||
        promulgatingAgency ||
        legalLevel ||
        validity?.length
    );

    if (hasAdvancedParams) {
      // 构造高级搜索参数（包含基础参数+高级参数）
      const advancedParams = {
        ...baseParams,
        effectiveStart: effectiveStart || undefined, // 空值设为 undefined，axios 会忽略
        effectiveEnd: effectiveEnd || undefined,
        promulgationStart: promulgationStart || undefined,
        promulgationEnd: promulgationEnd || undefined,
        promulgatingAgency: promulgatingAgency || undefined,
        legalLevel: legalLevel || undefined,
        validity: validity?.length ? validity.join(',') : undefined
      };
      // 调用高级搜索接口
      return service.get('http://159.75.99.168:8080/api/laws/advancedSearch', {
        params: advancedParams
      });
    } else {
      // 调用基础搜索接口（仅传递基础参数）
      return service.get('http://159.75.99.168:8080/api/laws/searchByTitleAndContent', {
        params: baseParams
      });
    }
  },
  /**
   * 高级搜索接口（显式调用）
   * @param {Object} params - 搜索参数
   * @returns {Promise}
   */
  advancedSearch: (params) => {
    return service.get('http://159.75.99.168:8080/api/laws/advancedSearch', {
      params: {
        keyword: params.query,
        type: params.type,
        pageNum: params.page,
        pageSize: params.limit,
        searchMode: params.searchMode,
        titleKey: params.type === 'both' ? params.query.split('&')[0]?.trim() : '',
        contentKey: params.type === 'both' ? params.query.split('&')[1]?.trim() : '',
        effectiveStart: params.effectiveStart || undefined,
        effectiveEnd: params.effectiveEnd || undefined,
        promulgationStart: params.promulgationStart || undefined,
        promulgationEnd: params.promulgationEnd || undefined,
        promulgatingAgency: params.promulgatingAgency || undefined,
        legalLevel: params.legalLevel || undefined,
        validity: params.validity?.length ? params.validity.join(',') : undefined
      }
    });
  },

  /**
   * 获取法规详情
   * @param {string} regulationId - 法规ID
   * @returns {Promise}
   */
  getRegulationDetail: (regulationId) => {
    return service.get(`/regulations/${regulationId}`);
  },

  /**
   * 获取热门搜索
   * @returns {Promise}
   */
  getHotSearches: () => {
    return service.get('/search/hot');
  }
};

export default searchApi;